import { everyTrue } from 'aa_common/front-end/helpers'
import { tryCallApi } from 'common/helpers'
import { AssetLedger } from 'common/models'
import { DepreciationResultAdjustHistoryService } from 'common/open-api'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDebouncedCallback } from 'use-debounce'

export const useIsEventAfterAccelerated = (assetLedger: AssetLedger) => {
  const [isEventAfterAccelerated, setIsEventAfterAccelerated] = useState(false)
  const { biid } = useParams<{ biid: string }>()
  const debounceFetchActionsStatus = useDebouncedCallback(async () => {
    const response = await tryCallApi(DepreciationResultAdjustHistoryService.getDepreciationResultsAdjustHistoryByBiid)(
      biid
    )
    if (response.data) {
      const plannedDate = response.data.data?.selected_date
      const eventDate = response.data.data?.last_fa_event?.valid_from
      const eventCode = response.data.data?.last_fa_event?.change_situation?.code

      setIsEventAfterAccelerated(
        everyTrue(!!eventCode, !!plannedDate, !!eventDate, moment(eventDate).isSameOrAfter(plannedDate))
      )
    }
  }, 250)

  // Re-check whenever the asset ledger changes
  useEffect(() => {
    debounceFetchActionsStatus()
  }, [debounceFetchActionsStatus, assetLedger])

  return isEventAfterAccelerated
}
